import { IconSVGProps } from '../types'

export const CalendarTodoIcon = ({ className, fill }: IconSVGProps) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.3335 2.00033H14.0002C14.177 2.00033 14.3465 2.07056 14.4716 2.19559C14.5966 2.32061 14.6668 2.49018 14.6668 2.66699V13.3337C14.6668 13.5105 14.5966 13.68 14.4716 13.8051C14.3465 13.9301 14.177 14.0003 14.0002 14.0003H2.00016C1.82335 14.0003 1.65378 13.9301 1.52876 13.8051C1.40373 13.68 1.3335 13.5105 1.3335 13.3337V2.66699C1.3335 2.49018 1.40373 2.32061 1.52876 2.19559C1.65378 2.07056 1.82335 2.00033 2.00016 2.00033H4.66683V0.666992H6.00016V2.00033H10.0002V0.666992H11.3335V2.00033ZM2.66683 6.00033V12.667H13.3335V6.00033H2.66683ZM4.00016 7.33366H5.3335V8.66699H4.00016V7.33366ZM4.00016 10.0003H5.3335V11.3337H4.00016V10.0003ZM6.66683 7.33366H12.0002V8.66699H6.66683V7.33366ZM6.66683 10.0003H10.0002V11.3337H6.66683V10.0003Z" />
  </svg>
)
